<app-header></app-header>
<div class="container-fluid">
  <mat-toolbar color="primary">
    <span>Tables & Columns Selection</span>
  </mat-toolbar>
  <div class="user-info">
    * Select tables to join and columns to display
  </div>
  <div class="section" fxLayout="row" fxLayoutGap="3%">
    <div>
      <mat-form-field appearance="fill">
        <mat-label>First Table</mat-label>
        <mat-select [attr.name]="'firstIndex'" [formControl]="firstIndexName"
                    (selectionChange)="onIndexChange('firstIndex', $event)">
          @for (firstIndex of firstIndices; track firstIndex) {
            <mat-option [value]="firstIndex">{{firstIndex}}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    <div>
      <mat-form-field appearance="fill">
        <mat-label>Second Table</mat-label>
        <mat-select [attr.name]="'secondIndex'" [formControl]="secondIndexName"
                    (selectionChange)="onIndexChange('secondIndex', $event)">
          @for (secondIndex of secondIndices; track secondIndex) {
            <mat-option [value]="secondIndex">{{secondIndex}}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  @if (indicesSelected) {
    <div fxLayout="row" fxLayoutGap="3%">
      @for (indexName of selectedIndicesArray; track indexName) {
        <div>
          <mat-form-field appearance="fill" style="width: 100%">
            <mat-label>Select {{indexName|titlecase}} columns</mat-label>
            <!--        <mat-select [(value)]="selectedColumns[indexName]"-->
            <!--                    (selectionChange)="taskId ? fetchFilteredResult() : fetchJoinedResult(false)" multiple>-->
            <mat-select [attr.name]="indexName" [(value)]="selectedColumns[indexName]" multiple>
              @for (col of indexData[indexName]['fields']; track col) {
                <mat-option [value]="col">
                  {{col.split('.').join(' ')|shortenTitle}}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      }
    </div>
  }

  @if (indicesSelected) {
    <div class="section">
      <app-index-filters
        [firstIndex]="selectedIndicesArray[0]"
        [secondIndex]="selectedIndicesArray[1]"
        [indexFilters]="indexData[selectedIndicesArray[0]]['fields']"
      >
      </app-index-filters>
      <div fxLayout="row" fxLayoutGap="3%">
        <div class="button-div">
          <button mat-raised-button color="primary" (click)="fetchJoinedResult(true)">Display Joined Data</button>
        </div>
        <div class="button-div">
          <button mat-raised-button color="primary" (click)="downloadFile()">Download Data (csv)</button>
        </div>
      </div>
    </div>
  }

  @if (showProgressBar) {
    <div class="progress-bar">
      <mat-progress-bar mode="query"></mat-progress-bar>
    </div>
  }

  @if (indicesSelected && searchSuccess) {
    <div class="data-table">
      @if (dataTable!.length > 0) {
        <div>
          <app-display-data
            [dataTable]="dataTable"
            [displayedColumns]="displayedColumns"
            [colLinks]="indexData[selectedIndicesArray[0]]['links']"
            [primaryField]="indexData[selectedIndicesArray[0]]['primary']"
            [firstIndex]="this.selectedIndicesArray[0]"
          ></app-display-data>
        </div>
      } @else {
        <p>No records have been found matching your filters.</p>
      }
    </div>
  }
  @if (errors.length>0 && !searchSuccess) {
    <div>
      <p>We have encountered the following errors. Please contact faang-dcc&#64;ebi.ac.uk for help.</p>
      @for (err of errors; track err) {
        <p>
          {{err}}
        </p>
      }
    </div>
  }

  <ng-template #filtersDialog>
    <h2 matDialogTitle>Adding Filters</h2>
    <div matDialogContent>
      <p>Please fill in the filter fields before continuing.</p>
      <p>To access the entire result set of the joined tables, download the results in CSV format by clicking
        on the 'Download' button </p>
    </div>
    <mat-dialog-actions>
      <button mat-button matDialogClose>Dismiss</button>
    </mat-dialog-actions>
  </ng-template>

  <ng-template #columnsDialog>
    <h2 matDialogTitle>Columns Selection</h2>
    <div matDialogContent>
      <p>Select fields to display from drop down menus.</p>
      <p>You should select at least one field from the {{selectedIndicesArray[0]|titlecase}} index</p>
    </div>
    <mat-dialog-actions>
      <button mat-button matDialogClose>Dismiss</button>
    </mat-dialog-actions>
  </ng-template>

</div>

